<template>
    <div>
        <div class="mb-3">
            <BackButton :href="$route('ftp.accounts')" to="FTP Accounts"/>
        </div>

        <div class="card card-body">
            <table class="table">
                <thead>
                <tr>
                    <th>Files</th>
                    <th>Size</th>
                    <th>Last Modification</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="directory !== ''">
                    <td colspan="3">
                        <Link as="a"
                            :href="$route('ftp.accounts.files', {username: username})">
                            <i class="fas fa-arrow-left mr-1"/>
                            {{ __('actions.back') }}
                        </Link>
                    </td>
                </tr>
                <tr v-for="entry in entries">
                    <td>
                        <div class="d-flex flex-row">
                            <div v-if="entry.type === 'file'">
                                <i class="fas fa-file mr-1"/>
                                {{ basename(entry.path) }}
                            </div>
                            <div v-else-if="entry.type === 'dir'">
                                <Link as="a" :href="$route('ftp.accounts.files', {username: username, dir: entry.path})">
                                    <i class="fas fa-folder mr-1"/>
                                    {{ basename(entry.path) }}
                                </Link>
                            </div>
                        </div>
                    </td>
                    <td>
                        <span v-if="entry.hasOwnProperty('file_size')">{{ entry.file_size.fileSize(1) }}</span>
                        <span v-else>-</span>
                    </td>
                    <td>
                        {{ $localDate(entry.last_modified) }}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/vue2';
import BackButton from "@components/BackButton.vue";

export default {
    components: {BackButton, Link},

    props: {
        directory: String,
        entries: Array,
        username: String,
    },

    methods: {
        basename(path) {
            let pathParts = path.split("/")
            if (pathParts.length > 0) {
                return pathParts.pop();
            }

            return path;
        },
    }
}
</script>
